import { initNavigation } from "./nav";
import { initLiveSearch } from "./live-search";
import { initCarousels } from "./carousel";
import { Lightbox } from "./lightbox";
import { initShopFilter } from "./shop-filter";
import { initDialogs } from "./dialogs";
import { initVideoPlayers } from "./video-player";
import { initHeroImages } from "./hero";
import { initLogoSlider } from "./logo-slider";
import { initServiceIconSlider } from "./service-icon-slider";
import { initReadMore } from "./read-more";
import { observeFit } from './utils/fit-to-longest-line';

document.addEventListener("DOMContentLoaded", () => {
  initHeroImages();
  initLogoSlider();
  initServiceIconSlider();
  initNavigation();
  initCarousels();
  initLiveSearch();
  initShopFilter();
  initDialogs();
  initVideoPlayers();
  initReadMore();
  observeFit('[data-fit-to-longest-line]');

  new Lightbox('a[data-lightbox]');
});
